// extracted by mini-css-extract-plugin
module.exports = {"bold":"CourtStep4AlertContent_bold__EqX4i","link":"CourtStep4AlertContent_link__3Rw3s"};